/**
 * created by li si yi
 * 微信待办处理
 */
import React, {Component} from 'react';
import WeChatPublish from "../../../../mediaRelease/weChatPublish/WeChatPublish";
import {connect} from "react-redux";
import BaseComponent from "../../../../../base/BaseComponent";

class Material extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {mediaId:''}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    data = {};

    isSupport(data) {
        // console.log('微信111111111111', data);
        this.data = data;
        if (this.data && this.data.data.id && this.data.data.mediaId && this.data.activitiCategoryKey === "material") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'OfficialIcon';
        return icon
    };
    handle = (data, call) => {
        this.setState({
            mediaId: data.data.mediaId,
        },()=>{
            this.weChatPublish.editMaterial(data.data.id, data.data.mediaId, () => {
                call && call()
            });
        })
    };

    render() {
        return (
            <div style={{display: 'none'}}>
                {/*微信*/}
                <WeChatPublish ref={ref => this.weChatPublish = ref} match={
                    {
                        params:{
                            currentMedia: this.state.mediaId
                        }
                    }
                }/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(Material)